// gatsby-browser.js
import "./src/index.css"; // Fonts or additional custom styles

import React from "react";
import { ThemeProvider } from "./src/components/ThemeContext";
import Layout from "./src/components/Layout";

export const wrapPageElement = ({ element, props }) => {
  return (
    <ThemeProvider>
      {element}
    </ThemeProvider>
  );
};
